import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Stack,
  Table,
  Form,
  Breadcrumb,
  Modal,
  InputGroup,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { isMobile, BrowserView } from "react-device-detect";
import ".././../assets/css/ListComponentsTable.css";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import PubSub from "pubsub-js";
import {
  LEAD_STATUS_VALUES,
  LIST_TAB_TITLE,
  PROJECT_STATUS_VALUES,
  sourceNames,
} from "../../constants/CONSTANT";
import {
  formatDate,
  formatDateForView,
  formatDateForViewIST,
  getUserDetails,
} from "../../utils/helper";
import DateRangePicker from "rsuite/DateRangePicker";
// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/DateRangePicker/styles/index.css";
import InfoPill from "../InfoPill";
import { ROUTES } from "../../constants/webRouting";
import { CSVUpload } from "../../utils/CSVUpload";
import * as constants from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";

const LeadList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();
  const [body, setBody] = useState();
  const [showLeadPhoneModal, setShowLeadPhoneModal] = useState(false);
  const [preCheckPhone, setPreCheckPhone] = useState("");
  const [preCheckResult, setPreCheckResult] = useState(null);
  const [preCheckLoading, setPreCheckLoading] = useState(false);
  const [contacts, setContacts] = useState();
  // const [filterData, setFilterData] = useState({ lead_status: "Enquiry Pending" });
  const [filterData, setFilterData] = useState({});
  const [dateRange, setDateRange] = React.useState([
    // new Date(),
    // new Date()
  ]);

  const [accounts, setAccounts] = useState([]);
  const [products, setProducts] = useState([]);
  const [rows, setRows] = useState([]);

  const [leadStatusArray, setleadStatusArray] = useState(
    constants.LEAD_STATUS_VALUES,
  );

  const [assignUsers, setAssignUsers] = useState([]);

  // Modified By Farhan Khan on 16-Feb-2026 (Added server-side pagination for performance)
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const PAGE_SIZE_OPTIONS = [5, 10, 50];

  useEffect(() => {
    setPage(1);
  }, [filterData, dateRange]);
  // End Here Comment By Farhan Khan on 16-Feb-2026

  useEffect(() => {
    const filter = { ...filterData };
    delete filter.owner_name;
    delete filter.product_name;
    filter.owner_ids = filter?.owner_ids
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    filter.account_id = filter?.accounts
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    delete filter.accounts;
    if (!filter.leadsource || String(filter.leadsource).trim() === "")
      delete filter.leadsource;
    if (Array.isArray(dateRange) && dateRange.length > 0)
      filter.date_range = {
        filed: "createddate",
        createddate: {
          from: formatDate(dateRange?.at(0) || null),
          to: formatDate(dateRange?.at(1) || null),
        },
      };
    // Modified By Farhan Khan on 16-Feb-2026 (Added server-side pagination for performance)
    filter.page = page;
    filter.pageSize = pageSize;
    // End Here Comment By Farhan Khan on 16-Feb-2026
    fetchLeads(filter);
  }, [dateRange, filterData, page, pageSize]);

  async function fetchLeads(filter) {
    console.log("first filter", filter);
    const result = await solisPowerApi.fetchLeads(filter);
    console.log("first result", result);
    if (result) {
      // Modified By Farhan Khan on 16-Feb-2026 (Added server-side pagination for performance)
      const isPaginated = result && typeof result === "object" && "data" in result;
      const rawData = isPaginated ? result.data : result;
      const dataArray = Array.isArray(rawData) ? rawData : [];
      if (isPaginated) {
        setTotal(result.total ?? 0);
      } else {
        setTotal(dataArray.length);
      }
      setBody(dataArray);
      setContacts(dataArray);
      const mappedRows = dataArray.map((item, index) => ({
        id: item.id || index,
        lead_number: item.lead_no || "",
        createddate: item.createddate || null,
        name: item.lead_name || "",
        address: item.customer_address || "",
        phone: item.phone || "",
        leadtype: item.leadtype || "",
        leadsource: item.leadsource || "",
        leadstatus: item.lead_status || "",
        owner_ids: Array.isArray(item.owner_ids) ? item.owner_ids : [],
        projects: Array.isArray(item.project_line_items) ? item.project_line_items : [],
      }));
      setRows(mappedRows);
      setFilteredRows(mappedRows);
      setTablePage(0);
      // End Here Comment By Farhan Khan on 16-Feb-2026
    } else {
      setBody([]);
      setContacts([]);
      setTotal(0);
    }
  }

  async function init() {
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((permission) => {
        return userInfo?.permissions.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedUsers = await solisPowerApi.fetchUsers();
      resultedUsers &&
        Array.isArray(resultedUsers) &&
        setAssignUsers(
          resultedUsers.map((user) => ({
            value: user.id,
            // label:
            //   user.userrole === "SUPER_ADMIN"
            //     ? user.username
            //     : user.userrole === "ADMIN"
            //     ? `${user.username} - (${user.user_type}) - (Manager)`
            //     : `${user.username} - (${user.user_type})`,
            label: user.username,
          })),
        );
    }

    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_MAKE].some((permission) => {
        return userInfo?.permissions.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedAccounts = await solisPowerApi.fetchAccounts();
      resultedAccounts &&
        Array.isArray(resultedAccounts) &&
        setAccounts(resultedAccounts);
    }

    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PRODUCT].some((permission) => {
        return userInfo?.permissions.map((p) => p.name).includes(permission);
      })
    ) {
      const fetchedContacts = await solisPowerApi.fetchProductsForEnquiry();
      Array.isArray(fetchedContacts) &&
        setProducts(
          fetchedContacts?.map((fetchedContact) => ({
            id: fetchedContact?.id,
            name: `${fetchedContact?.name || ""}`,
          })),
        );
    }
  }

  useEffect(() => {
    init();
  }, []);

  console.log("userInfo ==> 1", userInfo.user_type);
  const header = [];

  if (userInfo.user_type === "Tele-Caller") {
    header.push(
      {
        title: "Lead Number",
        prop: "lead_no",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={"/leads/" + row.id} state={row}>
            {row.lead_no}
          </Link>
        ),
      },
      {
        title: "Name",
        prop: "lead_name",
        // cell: (row) => (
        //   <Link to={"/leads/" + row.id} state={row}>
        //     {row.lead_name}
        //   </Link>
        // ),
        isFilterable: true,
      },
      // {
      //   title: "Lead Type",
      //   prop: "leadtype",
      //   isFilterable: true,
      // },
      {
        title: "Phone",
        prop: "phone",
        isFilterable: true,
      },
      {
        title: "Created Date",
        prop: "createddate",
        isFilterable: true,
        isSortable: true,
        cell: (row) =>
          row?.createddate ? formatDateForViewIST(row.createddate) : "",
      },

      {
        title: "Address",
        prop: "customer_address",
        isFilterable: true,
      },
      // {
      //   title: "City",
      //   prop: "city",
      //   isFilterable: true,
      // },
      // {
      //   title: "Lead Status",
      //   prop: "lead_status",
      //   isFilterable: true,
      //   isSortable: true,
      //   alignment: { horizontal: "center" },
      //   cell: (row) => (
      //     <span
      //       className="badge rounded-pill w-100 d-block"
      //       style={getStatusClass(row.lead_status)}
      //     >
      //       {row.lead_status}
      //     </span>
      //   ),
      // },
      {
        title: "Assign Users",
        prop: "owner_ids",
        cell: (row) => (
          <div className="d-flex flex-wrap gap-1">
            {row.owner_ids?.map(
              (item, index) =>
                item?.value && (
                  <Link
                    key={index}
                    state={row}
                    className="text-decoration-none"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "2px 6px", // 👈 VERY IMPORTANT
                      fontSize: "10px",
                      lineHeight: "1",
                      borderRadius: "999px",
                      background: "#f5f7fa",
                      border: "1px solid #e0e0e0",
                      color: "#1a73e8",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#eaf1ff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "#f5f7fa")
                    }
                  >
                    {/* <img
                    src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                    className="rounded-circle"
                    style={{
                      height: "30px",
                      width: "30px",
                      objectFit: "cover",
                      border: "2px solid #007bff",
                    }}
                    alt=""
                  /> */}
                    <span className="fw-semibold text-primary">
                      {item.label}
                      {item.user_type && (
                        <span
                          className="badge rounded-pill bg-light text-dark border"
                          style={{ fontSize: "10px" }}
                        >
                          {item.user_type}
                        </span>
                      )}
                    </span>
                  </Link>
                ),
            )}
          </div>
        ),
        isFilterable: true,
        isSortable: true,
      },
    );
  } else if (userInfo.user_type === "Sales Person") {
    header.push(
      {
        title: "Lead Number",
        prop: "lead_no",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={"/leads/" + row.id} state={row}>
            {row.lead_no}
          </Link>
        ),
      },
      {
        title: "Lead Source",
        prop: "leadsource",
        isFilterable: true,
      },
      {
        title: "Sanction Load",
        prop: "sanction_load",
        isFilterable: true,
      },
      {
        title: "Type of Project",
        prop: "type_of_project",
        isFilterable: true,
      },
      {
        title: "Module Type",
        prop: "dcr",
        isFilterable: true,
      },
      {
        title: "Created Date",
        prop: "createddate",
        isFilterable: true,
        isSortable: true,
        cell: (row) =>
          row?.createddate ? formatDateForViewIST(row.createddate) : "",
      },
      {
        title: "Address",
        prop: "address",
        isFilterable: true,
      },
      // {
      //   title: "City",
      //   prop: "city",
      //   isFilterable: true,
      // },
      {
        title: "Assign Users",
        prop: "owner_ids",
        cell: (row) => (
          <div className="d-flex flex-wrap gap-1">
            {row.owner_ids?.map(
              (item, index) =>
                item?.value && (
                  <Link
                    key={index}
                    // to={`${ROUTES.USER.LIST}/${item.value}`}
                    state={row}
                    className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                    style={{
                      background: "#f5f7fa",
                      border: "1px solid #e0e0e0",
                      transition: "0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#eaf1ff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "#f5f7fa")
                    }
                  >
                    {/* <img
                    src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                    className="rounded-circle"
                    style={{
                      height: "30px",
                      width: "30px",
                      objectFit: "cover",
                      border: "2px solid #007bff",
                    }}
                    alt=""
                  /> */}
                    <span className="fw-semibold text-primary">
                      {item.label}
                    </span>
                  </Link>
                ),
            )}
          </div>
        ),

        isFilterable: true,
        isSortable: true,
      },
    );
  } else {
    header.push(
      {
        title: "Lead Number",
        prop: "lead_no",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={"/leads/" + row.id} state={row}>
            {row.lead_no}
          </Link>
        ),
      },
      {
        title: "Created Date",
        prop: "createddate",
        isFilterable: true,
        cell: (row) =>
          row?.createddate ? formatDateForViewIST(row.createddate) : "",
        isSortable: true,
      },
      {
        title: "Name",
        prop: "lead_name",
        // cell: (row) => (
        //   <Link to={"/leads/" + row.id} state={row}>
        //     {row.lead_name}
        //   </Link>
        // ),
        isFilterable: true,
        //  isSortable: true,
      },
      {
        title: "Address",
        prop: "customer_address",
        isFilterable: true,
        // isSortable: true,
      },
      // {
      //   title: "City",
      //   prop: "city",
      //   isFilterable: true,
      //   // isSortable: true,
      // },
      {
        title: "Phone",
        prop: "phone",
        isFilterable: true,
        // isSortable: true,
      },
      // {
      //   title: "Lead Type",
      //   prop: "leadtype",
      //   isFilterable: true,
      //   // isSortable: false,
      // },
      {
        title: "Lead Source",
        prop: "leadsource",
        isFilterable: true,
        // isSortable: false,
      },
      {
        title: "Lead Status",
        prop: "lead_status",
        isFilterable: true,
        isSortable: true,
        alignment: { horizontal: "center" },
        cell: (row) => (
          <span
            className="badge rounded-pill w-100"
            style={getStatusClass(row.lead_status)}
          >
            {row.lead_status}
          </span>
        ),
      },
      {
        title: "Assign Users",
        prop: "owner_ids",
        cell: (row) => (
          <div className="d-flex flex-wrap gap-1">
            {row.owner_ids?.map(
              (item, index) =>
                item?.value && (
                  <Link
                    key={index}
                    // to={`${ROUTES.USER.LIST}/${item.value}`}
                    state={row}
                    className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                    style={{
                      background: "#f5f7fa",
                      border: "1px solid #e0e0e0",
                      transition: "0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#eaf1ff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "#f5f7fa")
                    }
                  >
                    {/* <img
                    src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                    className="rounded-circle"
                    style={{
                      height: "30px",
                      width: "30px",
                      objectFit: "cover",
                      border: "2px solid #007bff",
                    }}
                    alt=""
                  /> */}
                    <span className="fw-semibold text-primary">
                      {item.label}
                    </span>
                  </Link>
                ),
            )}
          </div>
        ),

        isFilterable: true,
        isSortable: true,
      },

      // {
      //   title: "Product",
      //   prop: "product_name",
      //   cell: (row) => (
      //     <Link to={`${ROUTES.PRODUCT.LIST}/${row.product_id}`} >
      //       {row.product_name}
      //     </Link>
      //   ),
      //   isFilterable: true,
      // },
    );
  }
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createLead = () => {
    // setShowLeadPhoneModal(true);
    // setPreCheckPhone("");
    // setPreCheckResult(null);
    navigate(ROUTES.LEAD.CREATE);
  };

  const handlePreCheckPhone = async (phoneValue) => {
    const digits = String((phoneValue ?? preCheckPhone) || "").replace(/\D/g, "").slice(0, 10);
    if (digits.length !== 10) return;
    setPreCheckLoading(true);
    setPreCheckResult(null);
    try {
      const result = await solisPowerApi.checkLeadPhone(digits);
      setPreCheckResult(result || { exists: false, lead: null });
    } catch (err) {
      setPreCheckResult({ exists: false, lead: null });
    } finally {
      setPreCheckLoading(false);
    }
  };

  const handlePreCheckUpdateLead = (leadId) => {
    setShowLeadPhoneModal(false);
    setPreCheckPhone("");
    setPreCheckResult(null);
    navigate(ROUTES.LEAD.EDIT.replace(":id", leadId));
  };

  const handlePreCheckCreateNew = () => {
    const digits = String(preCheckPhone || "").replace(/\D/g, "").slice(0, 10);
    setShowLeadPhoneModal(false);
    setPreCheckPhone("");
    setPreCheckResult(null);
    navigate(ROUTES.LEAD.CREATE, { state: { prefilledPhone: digits } });
  };

  const handlePreCheckClose = () => {
    setShowLeadPhoneModal(false);
    setPreCheckPhone("");
    setPreCheckResult(null);
  };

  //This is Using to Copy Form Url of Enquiry Form.
  const handleCopyLinkUrl = () => {
    let url = `${window.location.origin}/enquiry_form`;
    // navigator.clipboard
    //   .writeText(url)
    //   .then(() => {
    //     PubSub.publish("RECORD_SAVED_TOAST", {
    //       title: "Successfully",
    //       message: "Successfully Copied Enquiry Form Url",
    //     });
    //   })
    //   .catch((err) => {
    //     console.error("Failed to copy: ", err);
    //   });

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(url)
        .then(() =>
          PubSub.publish("RECORD_SAVED_TOAST", {
            title: "Successfully",
            message: "Successfully Copied Enquiry Form Url",
          }),
        )
        .catch((err) => {
          console.warn("Clipboard API failed, using fallback", err);
          // fallbackCopyToClipboard(url);
        });
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Error",
        message: "Field to Copy Enquiry Form Url",
      });
      // fallbackCopyToClipboard(url);
    }
  };

  //For Searching Filteration Clear.
  const handleClear = () => {
    setFilterData({});
    setDateRange([]);
    setPage(1);
    // handleSearch();
  };

  const getStatusClass = (status) => {
    const statusObj = LEAD_STATUS_VALUES.find(
      (value) => value.label === status,
    );
    return statusObj ? statusObj.css : {};
  };

  const getProjectStatusClass = (status) => {
    const statusObj = (PROJECT_STATUS_VALUES || []).find(
      (value) => value.label === status,
    );
    return statusObj ? statusObj.css : { backgroundColor: "#6c757d", color: "#fff" };
  };

  const [expandedLeadId, setExpandedLeadId] = useState(null);
  const handleExpandRow = (leadId) => {
    setExpandedLeadId((prev) => (prev === leadId ? null : leadId));
  };

  const handleChange = (e) => {
    setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };

  const customFilter = (rows, filters) => {
    return rows.filter((row) => {
      return Object.keys(filters).every((column) => {
        const filterValue = filters[column]?.toLowerCase() || "";
        if (!filterValue) return true; // filter empty hai to row include karo

        const rowValue = row[column]?.toString().toLowerCase() || "";
        return rowValue.includes(filterValue); // substring + case-insensitive
      });
    });
  };

  // add by alfaiz ansari start here
  const [searchText, setSearchText] = useState("");
  const [filteredRows, setFilteredRows] = useState(rows);
  const [tablePage, setTablePage] = useState(0);
  // Modified By Farhan Khan on 16-Feb-2026 (Added server-side pagination for performance - no client slice)
  const handleSearch = (value) => {
    setSearchText(value);
    setTablePage(0);
    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredRows(filtered);
  };
  const paginatedRows = filteredRows;
  const totalPages = Math.ceil(total / pageSize) || 1;
  // End Here Comment By Farhan Khan on 16-Feb-2026
  // add by alfaiz ansari end here

  return (

    <div className="container-fluid px-3 py-3 flex-grow-1 bg-white shadow-sm rounded-lg lead-list-page">
      <DatatableWrapper
        body={body && Array.isArray(body) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50],
          },
        }}
        sortProps={{ initialState: { prop: "createddate", order: "desc" } }}
        filterFunction={customFilter}
      >
        <Row className="lead-list-filters">
          {/* <p style={{ fontSize: "22px", display: "flex", justifyContent: "center", fontWeight: "bold" }}>Search Filter</p> */}
          <Col md={12} className="">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => navigate(ROUTES.LEAD.LIST)}>
                Leads
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          {/* <Col lg={2}>
            <Form.Group className="mt-2">
              <Form.Label className="form-view-label" htmlFor="formBasicState">
                Commission
              </Form.Label>

              <Select
                isMulti
                className="z-3"
                placeholder="Select your account"
                options={accounts?.map((account) => ({
                  value: account?.id,
                  label: account?.name,
                }))}
                onChange={(e) => {
                  handleChange({
                    target: { name: "accounts", value: e },
                  });
                }}
                value={filterData?.accounts?.filter((item) => item.value)}
              ></Select>
              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>
          </Col> */}
          {/* <Col lg={3}>
            <Form.Group className="mt-2">
              <Form.Label className="form-view-label" htmlFor="formBasicLead">
                Lead Type
              </Form.Label>
              <Form.Select
                aria-label="Select lead type"
                name="leadtype"
                value={filterData?.leadtype || ""}
                onChange={handleChange}
              >
                <option value="">---Select---</option>
                {["New", "Modification", "AMC", "OneTime"].map(
                  (item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  ),
                )}
              </Form.Select>

              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>
          </Col> */}
          <Col lg={3}>
            <Form.Group className="mt-2">
              <Form.Label>Lead Source</Form.Label>
              <Form.Select
                name="leadsource"
                value={filterData?.leadsource || ""}
                onChange={handleChange}
              >
                <option value="">All Lead Sources</option>
                {sourceNames?.map((item, index) => (
                  <option value={item} key={index}>
                    {item}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicLeadManagerId"
              >
                Assigned Users
              </Form.Label>
              <Select
                // isClearable
                className="z-3"
                isMulti
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
                name="owner_ids"
                onChange={(e) => {
                  console.log("Selected owner_ids =>", e);
                  console.log("Old filterData =>", filterData);
                  handleChange({
                    target: { name: "owner_ids", value: e },
                  });
                }}
                value={filterData?.owner_ids?.filter((item) => item.value)}
                options={assignUsers}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="align-items-end my-3">
          <Col lg={2} md={4} xl={2} sm={12} className="">
            {/* <Filter
              classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }}
            /> */}
            <div className="leads-header">
              <div className="leads-actions">
                <TextField
                  size="small"
                  placeholder="Search leads..."
                  className="custom-search-field"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
          </Col>
          {/* <Col md={4} xl={1} lg={1} sm={12} className="">
            <PaginationOptions labels={labels} />
          </Col> */}

          <Col lg={2} md={4} sm={12} className="d">
            <DateRangePicker
              value={dateRange}
              onChange={(e) => {
                setDateRange(e);
              }}
              character=" – "
            />
          </Col>

          <Col lg={2} md={4} sm={12} className="py-1 ">
            {/* <BrowserView> */}
            <div className="d-flex py-1 px-2">
              <InfoPill
                left="Total"
                right={body?.length}
                rightClasses="bg-custom text-white border-white fw-bold"
                leftClasses="bg-white  fw-bold "
              />
            </div>
            {/* </BrowserView> */}
          </Col>
          <Col
            lg={3}
            md={4}
            className="space-col"
            style={{ textAlign: "end" }}
          ></Col>
          <Col
            sm={6}
            md={4}
            lg={3}
            className="d-flex flex-col justify-content-end align-items-end new-lead "
          >
            <Stack direction="horizontal" gap={2}>
              {/* <Button variant="success" onClick={handleSearch}><i class="fas fa-search"></i></Button> */}
              <Button variant="secondary" onClick={handleClear}>
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </Button>
              {/* <CSVUpload userInfo={getUserDetails()} init={init} parent={"lead"}/> */}
              {/* <Button
                size="sm"
                className="btn-create-enquiry"
                onClick={handleCopyLinkUrl}
              >
                Enquiry Form Url
              </Button> */}
              {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_LEAD].some(
                (permission) => {
                  return userInfo?.permissions
                    .map((p) => p.name)
                    .includes(permission);
                },
              ) && (
                  <Button
                    size="sm"
                    className="btn-create"
                    onClick={() => createLead(true)}
                  >
                    New Lead
                  </Button>
                )}
            </Stack>
          </Col>
        </Row>

        {/* <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader
              classes={{ th: "bg-custom text-white sticky-header" }}
            />
            {body && Array.isArray(body) ? (
              <TableBody />
            ) : (
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div> */}
        {/* <Pagination
          classes={{
            buttonGroup: "btn-custom",
            button: "bg-custom border-white",
          }}
        /> */}
      </DatatableWrapper>

      <div className="leads-page">
        {/* Table with row-level accordion: projects shown directly below expanded lead row */}
        <div
          style={{
            width: "100%",
            marginTop: "20px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          }}
          className="overflow-auto"
        >
          <Table striped bordered hover className="mb-0">
            <thead className="bg-custom text-white">
              <tr>
                <th style={{ width: 48 }}></th>
                <th>Lead Number</th>
                <th>Name</th>
                <th>Address</th>
                <th>Phone Number</th>
                <th>Lead Source</th>
                <th>Created Date</th>
                {/* <th>Status</th> */}
                <th>Assign Users</th>
              </tr>
            </thead>
            <tbody>
              {paginatedRows.map((row) => (
                <React.Fragment key={row.id}>
                  <tr>
                    <td className="align-middle">
                      <Button
                        variant="link"
                        size="sm"
                        className="p-0 min-w-0 text-dark"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleExpandRow(row.id);
                        }}
                        aria-label={expandedLeadId === row.id ? "Collapse" : "Expand"}
                      >
                        {expandedLeadId === row.id ? (
                          <ExpandLessIcon fontSize="small" />
                        ) : (
                          <ExpandMoreIcon fontSize="small" />
                        )}
                      </Button>
                    </td>
                    <td className="align-middle">
                      <Link
                        to={ROUTES.LEAD.VIEW.replace(":id", row.id)}
                        state={row}
                        style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}
                      >
                        {row.lead_number}
                      </Link>
                    </td>
                    <td className="align-middle">{row.name}</td>
                    <td className="align-middle">{row.address}</td>
                    <td className="align-middle">{row.phone}</td>
                    <td className="align-middle">{row.leadsource}</td>
                    <td className="align-middle">
                      {row?.createddate ? formatDateForViewIST(row.createddate) : ""}
                    </td>
                    {/* <td className="align-middle">
                      <span
                        className="badge rounded-pill w-100 d-block"
                        style={getStatusClass(row.leadstatus)}
                      >
                        {row.leadstatus}
                      </span>
                    </td> */}
                    <td className="align-middle">
                      <div className="d-flex flex-wrap gap-1">
                        {row.owner_ids?.map(
                          (item, index) =>
                            item?.value && (
                              <Link
                                key={index}
                                state={row}
                                className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                                style={{
                                  background: "#f5f7fa",
                                  border: "1px solid #e0e0e0",
                                  transition: "0.2s",
                                }}
                              >
                                <span className="fw-semibold text-primary" style={{ fontSize: "11px" }}>
                                  {item.label}
                                  {item.user_type && (
                                    <span className="badge rounded-pill bg-light text-dark border ms-1" style={{ fontSize: "10px" }}>
                                      {item.user_type}
                                    </span>
                                  )}
                                </span>
                              </Link>
                            )
                        )}
                      </div>
                    </td>
                  </tr>
                  {/* Projects accordion row - directly below this lead row */}
                  {expandedLeadId === row.id && (
                    <tr>
                      <td colSpan={9} className="p-0 border-start border-end">
                        <div className="p-3 bg-light">
                          {row.projects?.length > 0 ? (
                            <Table striped bordered size="sm" className="mb-0">
                              <thead className="bg-custom text-white">
                                <tr>
                                  <th>Project Name</th>
                                  <th>Address</th>
                                  <th>Status</th>
                                  <th>Created Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {row.projects.map((p) => (
                                  <tr key={p.id}>
                                    <td>
                                      <Link
                                        to={ROUTES.LEAD.VIEW.replace(":id", row.id)}
                                        state={row}
                                        style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}
                                      >
                                        {p.site_name || "-"}
                                      </Link>
                                    </td>
                                    <td>
                                      <span
                                      // className="badge rounded-pill"
                                      // style={getProjectStatusClass(p.project_status)}
                                      >
                                        {p.address || ""}
                                      </span>
                                    </td>
                                    <td>
                                      <span
                                        className="badge rounded-pill"
                                        style={getProjectStatusClass(p.project_status)}
                                      >
                                        {p.project_status || "-"}
                                      </span>
                                    </td>
                                    <td>
                                      {p.createddate ? formatDateForViewIST(p.createddate) : "-"}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          ) : (
                            <p className="mb-0 text-muted">No Projects Available</p>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>
        {/* Modified By Farhan Khan on 16-Feb-2026 (Added server-side pagination controls with page size dropdown) */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mt-2 px-2 gap-2">
          <div className="d-flex align-items-center gap-2">
            <Form.Select
              size="sm"
              style={{ width: "auto" }}
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1);
              }}
            >
              {PAGE_SIZE_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>
                  {opt} per page
                </option>
              ))}
            </Form.Select>
            <span className="text-muted small">
              Page {page} of {totalPages} ({total} total)
            </span>
          </div>
          <div className="d-flex gap-1 align-items-center flex-wrap">
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={page <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            >
              Previous
            </Button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) pageNum = i + 1;
              else if (page <= 3) pageNum = i + 1;
              else if (page >= totalPages - 2) pageNum = totalPages - 4 + i;
              else pageNum = page - 2 + i;
              return (
                <Button
                  key={pageNum}
                  size="sm"
                  variant={page === pageNum ? "primary" : "outline-secondary"}
                  onClick={() => setPage(pageNum)}
                >
                  {pageNum}
                </Button>
              );
            })}
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={page >= totalPages}
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            >
              Next
            </Button>
          </div>
        </div>
        {/* End Here Comment By Farhan Khan on 16-Feb-2026 */}
      </div>
    </div>
  );
};

export default LeadList;
